import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './components/App';
import configureStore from './utils/configureStore';
import LogRocket from 'logrocket';
import registerServiceWorker from './utils/registerServiceWorker';
import './styles/index.css';

import {LicenseManager} from "ag-grid-enterprise/main";

LicenseManager.setLicenseKey("Too_Symphony_Solutions,_LLC__MultiApp_1Devs19_March_2020__MTU4NDU3NjAwMDAwMA==663461dd25ab08780f829ee0ad3add31");


let lrConfig = {release: "2020-03-10.0", console: {isEnabled: false}};
LogRocket.init('agencyleads/nightsky', lrConfig);


ReactDOM.render((
  <Provider store={configureStore()}>
    <Router>
      <App/>
    </Router>
  </Provider>
), document.getElementById('root'));

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js